document.addEventListener('DOMContentLoaded', () => {
  const lists = document.querySelectorAll('.resource-list--grid');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {

      if (!entry.isIntersecting) return;

      const cards = entry.target.querySelectorAll('.collection-card');

      cards.forEach((card, index) => {
        setTimeout(() => {
          card.classList.add('is-visible');
        }, index * 180);
      });

      observer.unobserve(entry.target);

    });
  }, {
    threshold: 0.15
  });


  lists.forEach((list) => {
    observer.observe(list);
  });
});